import Svg from 'tio-employee/components/svg';
import { t } from 'ember-intl';
import { LinkTo } from '@ember/routing';
import Tile from '../tile';

<template>
  <LinkTo @route="authenticated.tas.mentoring">
    <Tile @headerText={{t "dashboard_tiles.tuition_assistance_mentoring"}}>
      <:description>
        {{t "dashboard_tiles.mentors_help" htmlSafe=true}}
      </:description>
      <:image>
        <Svg
          @name="mentoring"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.mentoring"}}
          class="lg:max-h-56 xl:max-h-full"
        />
      </:image>
    </Tile>
  </LinkTo>
</template>
